<template>
    <div class="ave__container">
        <ave-eyecatcher v-if="eyecatcherLines.length" :lines="eyecatcherLines" />
        <div class="ave__search__input">
            <label for="ave_search" class="ave__search__label">{{ $t('keyword.label') }}</label>
            <div class="ave__search__input--input-icon">
                <input type="text" maxlength='100' id="ave_search" class="search__field" :placeholder="$t('keyword.placeholder')"
                       v-model="text_query">
                <global-button theme="secondary" v-if="text_query !== ''" class="ave_search__reset" @click="reset" icon="close" />
            </div>
        </div>
        <ave-search :query="text_query" />
    </div>
</template>

<script>
import AveEyecatcher from '@src/Resources/epim/Templates/AvailabilityEntrypage/components/ave-eyecatcher/ave-eyecatcher';
import AveSearch from '@src/Resources/epim/Templates/AvailabilityEntrypage/components/ave-search/ave-search';
import GlobalButton from "@global/global-elements/global-button/global-button";
export default {
name: "availabilityentrypage",
    components: {GlobalButton, AveSearch, AveEyecatcher },
    props: {
        eyecatcherLines: Array
    },
    data() {
        return {
            text_query: ''
        }
    },
    methods: {
        reset() {
            this.text_query = ''
        }
    }
}
</script>
